import api from "./api";
import { ItemUnitType } from "../components/References/Unit/unitType";
export type DeleteItemUnit = {
  id: number | string;
};

export const getItemUnitDropdown = async () => {
  return await api.get("/item-units/dropdown");
};

export const getItemUnit = async () => {
  return await api.get("/item-units");
};

/*Delete*/
export const deleteItemUnit = async (dto: DeleteItemUnit) => {
  return await api.delete(`/item-units/${dto.id}`);
};

/*By Id*/
export const getItemUnitById = async (unitId: string | undefined) => {
  return await api.get(`/item-units/${unitId}`);
};

/*Create*/
export const createItemUnit = async (unitDetails: ItemUnitType) => {
  return await api.post("/item-units", unitDetails);
};

/*edit*/
export const editItemUnit = async (unitId: any, body: ItemUnitType) => {
  return await api.put(`/item-units/${unitId}`, body);
};

/*search & filter & limit*/
export const getItemUnitApi = async (body: { limit: number; q: string; isActive?: boolean }) => {
  let url = `/item-units?limit=${body.limit}&q=${body.q}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};